import type { z } from 'zod';

import type { IdFloorRuleDto, IdHeaderTagDto, IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

import type { createSchema } from './schema.ts';

type Schema = ReturnType<typeof createSchema>;
export type FormValues = z.input<Schema>;
export type SubmitValues = z.output<Schema>;

export interface CompanyFloorRuleFormRouteParams {
  integrationType?: IntegrationType;
  floorRuleId?: IdFloorRuleDto;
  headerTagId?: IdHeaderTagDto;
}

export enum CompanyFloorRuleFormSearchKey {
  HEADER_TAG_ID = 'headerTagId',
}
